import React, { useEffect, useState } from "react";
// css comes in CreatePublishPreRead.css
import Switch from "@mui/material/Switch";
import {
  DatePickerComponent,
  TimePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import moment from "moment";
import axios from "../../../../../../axios";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import SuccessfullPreRead from "../../../../Create_Assessment_PreRead/create_successfullPreRead/SuccessfullPreRead";
import Example from "../../../../Create_Assessment_PreRead/create_published/SelectDropdown";
import { MultiSelect } from "react-multi-select-component";
import { toast } from "react-toastify";

const DraftPublishPreRead = ({ setPublish, newPreRead, updatePreread }) => {
  // console.log("newPreRead", newPreRead);
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [lectureDate, setLectureDate] = useState();

  const [updatelivedropdowns, setUpdatelivedropdowns] = useState([]);
  // const [updateSlistDropdown1, setUpdateSlistDropdown1] = useState([]);
  const [slistDropdown1, setSlistDropdown1] = useState([]);
  let dummyArr = [];
  const [selected, setSelected] = useState([]);
  const [preAssigned, setPreAssigned] = useState([]);

  const options = slistDropdown1;

  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  // const [getStudentlist, setGetStudentList] = useState([]);
  const [slistDropdown, setSlistDropdown] = useState([]);
  const [getStudentlist, setGetStudentList] = useState({
    selectedData: "",
  });
  const { selectedData } = getStudentlist;
  const dataArray = selected;
  const idArray = dataArray?.map((obj) => obj?.value);

  const [draftpublishSucess, setDraftpublishSucess] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const helper = () => {
      if (preUpdateState.deadline !== "") {
        if (idArray?.length > 0) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(true);
      }
    };
    helper();
  });

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleChange1 = (event) => {
    setChecked1(event.target.checked);
  };
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  // const Teacher_Json = "62d98b5e0cb0b264330e6d0e";
  let subjectId = newPreRead?.subject_id?.id;
  let sectionId = newPreRead?.section_id?.id;
  let standarId = newPreRead?.standard_id?.id;

  useEffect(() => {
    const helper = async () => {
      let response = await axios.get(
        `/api/v1/homework/preReadId/${newPreRead.id}/studentList/get?status=draft&isOnlyList=true`,
      );
      // response.data.data.forEach((obj) => {
      //   let res = {
      //     label: obj.student_id.name,
      //     value: obj.student_id.id,
      //   };
      //   const exists = preAssigned.some((i) => i.value === res.value);
      //   if (!exists) {
      //     setPreAssigned([...preAssigned, res]);
      //   }
      // });

      let existingStudentsList = [];
      response &&
        response.data.data.map((student) =>
          existingStudentsList.push({
            value: student.student_id?.id,
            label: student.student_id?.name,
          }),
        );
      setSelected(existingStudentsList);
    };
    helper();
  }, [Teacher_Json]);

  useEffect(() => {
    const getActivtyStudentList = async () => {
      if (!timeTableSessionId) {
        return;
      }
      try {
        const studentList = await axios.get(
          `/api/v1/school/student/getList?standardId=${standarId}&sectionId=${sectionId}&timetableSession=${timeTableSessionId}`,
        );
        dummyArr = [];
        studentList.data.data.forEach((obj) => {
          let res = {
            value: `${obj.id}`,
            label: `${obj.name}`,
          };
          dummyArr.push(res);
        });
        setSlistDropdown1(dummyArr);
        studentList && setSlistDropdown(studentList.data.data);
      } catch (error) {}
    };
    getActivtyStudentList();
  }, [standarId]);

  // useEffect(() => {
  //   const getUpdateStudentList = async () => {
  //     try {
  //       const studentList = await axios.get(
  //         `/api/v1/school/student/getList?standardId/${standarId}`
  //       );
  //       let dummyArr = [];
  //       studentList.data.data.forEach((obj) => {
  //         let res = {
  //           value: `${obj.id}`,
  //           label: `${obj.name}`,
  //         };
  //         dummyArr.push(res);
  //       });
  //       setSlistDropdown1(dummyArr);
  //       studentList && setSlistDropdown1(studentList.data.data);
  //     } catch (error) {}
  //   };
  //   getUpdateStudentList();
  // }, [standarId]);

  const handleChange12 = (selected) => {
    setSelected(selected);
  };

  const [preUpdateState, setPreUpdateState] = useState({
    updateDeadline: "",
    updateScheduleDate: "",
    updateScheduleTime: "",
    updateStandared: "",
    UpdateliveSession: null,
    UpdateliveSessionDate: null,
    studentList: "",
    updateSubject: "",
    updateSection: "",
    updateChapter: "",
    updatePreType: "",
  });
  const {
    updateDeadline,
    updateScheduleDate,
    updateScheduleTime,
    UpdateliveSession,
    UpdateliveSessionDate,
  } = preUpdateState;
  const { description, attach, updateTittle } = updatePreread;

  useEffect(() => {
    const updatelivesessionDropdown = async () => {
      if (!academicYearId || !timeTableSessionId) {
        toast.error(
          "These are no allocations set for your login. Please contact school admin for the assistance.",
        );
        return;
      }
      try {
        if (preUpdateState?.deadline !== "") {
          const UpdateliveSession = await axios.get(
            `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${standarId}/sectionId/${sectionId}/timetableSessionId/${timeTableSessionId}/subjectId/${subjectId}/date/${lectureDate}`,
          );
          // UpdateliveSession.data.data.forEach((item) => {
          UpdateliveSession &&
            setUpdatelivedropdowns(UpdateliveSession?.data?.data[0].lectures);
          // });
        }
      } catch (error) {}
    };
    updatelivesessionDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureDate]);

  let updateCreatePre = {
    standard_id: newPreRead?.standard_id?.id,
    subject_id: newPreRead?.subject_id?.id,
    section_id: newPreRead?.section_id?.id,
    book_id: newPreRead?.book_id?.id,
    chapter_id: newPreRead?.chapter_id?.id,
    type: newPreRead?.type?.id,
    academic_session_id: academicSessionId,
    timetable_session_id: timeTableSessionId,
    deadline: updateDeadline || newPreRead?.deadline,
    schedule_date: updateScheduleDate || newPreRead?.schedule_date,
    schedule_time: updateScheduleTime || newPreRead?.schedule_time,
    add_to_live_session: {
      lecture_id: UpdateliveSession,
      date: UpdateliveSessionDate,
    },
    teacher_id: Teacher_Json,
    name: updateTittle,
    description,
    attachments: attach,
    status: "Published",
  };
  const handelUpdatePublish = async (e) => {
    // e.preventDefault();
    // console.log("updateCreatePre", updateCreatePre);
    if (attach) {
      const formData = new FormData();
      formData.append("name", attach.name);
      formData.append("uploadPreReadAttachment", attach);
      try {
        const res = await axios.post(
          `/api/v1/preRead/uploadAttachment/teacherId/${Teacher_Json}`,
          formData,
        );
        updateCreatePre.attachments = res.data.data;
      } catch (error) {
        console.log(error);
      }
    }
  };

  const helper = async () => {
    try {
      const res = await axios.post(
        `/api/v1/homework/preRead/update/${newPreRead.id}`,
        updateCreatePre,
      );

      if (res) {
        let students_id = [];
        for (const student of selected) {
          students_id.push(student.value);
        }
        let newStudentAssessment = {
          teacher_id: Teacher_Json,
          student_id: students_id,
          status: "pending",
          deadline: updateCreatePre?.deadline,
        };
        let studentRes = await axios.post(
          `/api/v1/homework/preRead/${res?.data?.data?.id}/studentPreRead/addStudents`,
          newStudentAssessment,
        );
      }
      // console.log(res.data.data);
      res && setDraftpublishSucess(true);
    } catch (error) {
      console.log(error);
    }
  };

  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };

  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }
  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadlines = preUpdateState?.updateDeadline || newPreRead?.deadline;
  if (deadlines) {
    var minLiveSessionDate = new Date(deadlines);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 7);
    var maxLiveSessionDate = new Date(deadlines);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }
  return (
    <>
      <div className="publish_transprant_body">
        {!draftpublishSucess && (
          <>
            <div className=" p-4 publish_white_containerPre ">
              <img
                alt=""
                src="/images/cross-circle3.svg"
                className="subActivityClosetBtn"
                onClick={(e) => setPublish(false)}
              />
              <h5 className="publish_header">{newPreRead?.status}</h5>
              <div className=" col-12 publish_field_boxs">
                {newPreRead?.subject_id?.name}
              </div>
              <div className=" col-12 publish_field_boxs">
                {newPreRead?.standard_id?.name}
              </div>
              <div className=" col-12 publish_field_boxs">
                {newPreRead?.section_id.name}
              </div>
              <div className=" col-12 m-0 p-0 px-2 EnterDeadlinePreread">
                <DateTimePickerComponent
                  min={minDateTime}
                  isDateDisabled={disablePastDates}
                  allowEdit={true}
                  placeholder="deadline"
                  id="datepicker"
                  value={newPreRead?.deadline}
                  onChange={(e) =>
                    setPreUpdateState({
                      ...preUpdateState,
                      updateDeadline: e.target.value,
                    })
                  }
                />
              </div>
              <div className="my-3 ">
                <MultiSelect
                  options={options}
                  value={selected}
                  onChange={handleChange12}
                  labelledBy="Select"
                  className="custom-multiselect w-100"
                />
                {/* <Example slistDropdown={slistDropdown1} /> */}
              </div>

              {/* <div className="my-3">
                <Example
                  // onClick={handelUncheckbox}
                  selectedData={selectedData}
                  slistDropdown={updateSlistDropdown1}
                  updateSlistDropdown={updateSlistDropdown} //use less
                />
              </div> */}
              <div className="btn_containers">
                {/* <div className="toggle_btn">
                  <div className="schedule_btns">
                    <span>Schedule</span>
                    <lable className="switch">
                      <Switch checked={checked} onChange={handleChange} />
                    </lable>
                  </div>
                  {checked && (
                    <>
                      <div className="schedule_box ">
                        <DatePickerComponent
                          allowEdit={false}
                          min={today}
                          isDateDisabled={disablePastDates}
                          id="datepicker"
                          placeholder="Schedule date"
                          value={newPreRead?.schedule_date}
                          onChange={(e) =>
                            setPreUpdateState({
                              ...preUpdateState,
                              updateScheduleDate: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="schedule_box ">
                        <TimePickerComponent
                          id="timepicker"
                          placeholder="Schedule time"
                          value={newPreRead?.schedule_time}
                          onChange={(e) =>
                            setPreUpdateState({
                              ...preUpdateState,
                              updateScheduleTime: e.target.value,
                            })
                          }
                        />
                      </div>
                    </>
                  )}
                </div> */}
                <div className="toggle_btn">
                  <div className="schedule_btns">
                    {deadlines ? (
                      <label className=" switch p-0 m-0">
                        <DatePickerComponent
                          id="datepicker"
                          placeholder="Add to Lecture Session"
                          width={230}
                          min={minLiveSessionDate}
                          max={maxLiveSessionDate}
                          allowEdit={false}
                          onChange={(e) => {
                            setChecked1(true);
                            setLectureDate(formatDate(e.target.value));
                            console.log(typeof e.target.value);
                          }}
                        />
                      </label>
                    ) : (
                      <>
                        <label className="deadlineNotSelect">
                          Add to Lecture Session
                        </label>
                        <img
                          src="/images/calIconDow.png"
                          alt=""
                          className="calDow"
                        />
                      </>
                    )}
                  </div>
                  {checked1 && (
                    <div className="schedule_box border-0 p-0">
                      <select
                        className="form-select col-12 py-2 m-0"
                        id="Schedule_sesion"
                        onChange={(e) =>
                          setPreUpdateState({
                            ...preUpdateState,
                            UpdateliveSession: e.target.value,
                            UpdateliveSessionDate: convertDateFormat(
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("schdate"),
                            ),
                          })
                        }
                      >
                        <option selected>Select Lecture</option>
                        {updatelivedropdowns?.length > 0 &&
                          updatelivedropdowns?.map((lecture, index) => (
                            <option
                              key={index}
                              value={lecture.id}
                              schdate={lecture.date}
                            >
                              {lecture.name}, {lecture.date},{" "}
                              {convertTimeStringToAMPM(lecture.start_time)}-
                              {convertTimeStringToAMPM(lecture.end_time)}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
              <div className="  publish_btn_box">
                <button
                  className="btn publish_btn"
                  onClick={() => {
                    // handelUpdatePublish();
                    helper();
                  }}
                  disabled={
                    isDisabled ||
                    (checked1 &&
                      lectureDate &&
                      !preUpdateState.UpdateliveSessionDate)
                  }
                >
                  Publish
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      {draftpublishSucess && <SuccessfullPreRead />}
    </>
  );
};

export default DraftPublishPreRead;
